<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2, makeBreaker } from '../../../Reusable/O3DG2'
import { loadGLTF } from '../../../Reusable/loadGLTF'
import { RectAreaLight } from 'three'
// import { Color } from 'three'
// import { BoxBufferGeometry, MeshBasicMaterial, Mesh } from 'three'
export default {
  mixins: [O3DG2],
  data () {
    return {
      controls: false
    }
  },
  async mounted () {
    this.modelURL = require('file-loader!../CityContent/glb/hospital.glb')
    let gltf = await loadGLTF(this.modelURL)
    let breaker = makeBreaker({ budget: 13.0 })
    gltf.scene.traverse((item) => {
      if (item.isMesh) {
        if (item.name === 'Cube.111_1') {
          // item.material.map = this.ctx.chromatics.out.envMap
        }
        if (item.name === 'Cube.111_0') {
          // item.material.emissive = new Color('#ffffff')
          // item.material.emissive = new Color('#1a1a1a')
          // item.material.envMap = this.ctx.chromatics.out.envMap
        }
      }
    })

    var width = 3600;
    var height = 3600;
    var intensity = 0.35;
    var rectLight = new RectAreaLight(0xffffff, intensity,  width, height);
    rectLight.position.set(0, -1, 0)
    rectLight.lookAt(0, 1, 0)
    this.o3d.add(rectLight)

    for ( var i = 0; i < 50; i ++ ) {
      await breaker()
      let building = gltf.scene.clone()
      building.position.x = Math.random() * 3600 - 3600 / 2
      building.position.y = 0
      building.position.z = Math.random() * 3600 - 3600 / 2
      building.scale.x = 20
      building.scale.y = 20
      building.scale.z = 20
      this.o3d.add(building)
    }
  }
}
</script>

<style>

</style>